import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-purchased-plans.reducer';

export const UserPurchasedPlansDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userPurchasedPlansEntity = useAppSelector(state => state.userPurchasedPlans.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userPurchasedPlansDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.userPurchasedPlans.detail.title">UserPurchasedPlans</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{userPurchasedPlansEntity.id}</dd>
          <dt>
            <span id="planEndDate">
              <Translate contentKey="fitengineerBackendV2App.userPurchasedPlans.planEndDate">Plan End Date</Translate>
            </span>
          </dt>
          <dd>
            {userPurchasedPlansEntity.planStartDate ? (
              <TextFormat value={userPurchasedPlansEntity.planStartDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dd>
            {userPurchasedPlansEntity.planEndDate ? (
              <TextFormat value={userPurchasedPlansEntity.planEndDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.userPurchasedPlans.user">User</Translate>
          </dt>
          <dd>{userPurchasedPlansEntity.user ? userPurchasedPlansEntity.user.login : ''}</dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.userPurchasedPlans.productDeliveryStatus">Product Delivery Status</Translate>
          </dt>
          <dd>{userPurchasedPlansEntity.productDeliveryStatus ? userPurchasedPlansEntity.productDeliveryStatus.status : ''}</dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.userPurchasedPlans.transactionDetails">Transaction Details</Translate>
          </dt>
          <dd>{userPurchasedPlansEntity.transactionDetails ? userPurchasedPlansEntity.transactionDetails.paymentTransactionId : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-purchased-plans" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-purchased-plans/${userPurchasedPlansEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserPurchasedPlansDetail;
